// ─── Design Tokens ────────────────────────────────────────────────────────────
export const FB = "#1877F2";
export const FB_DARK = "#1457B5";
export const FB_LIGHT = "#E7F3FF";
export const FB_MID = "#E0E0E0";
export const SURFACE = "#FFFFFF";
export const BG = "#EEEEEE";
export const BORDER = "#E0E0E0";
export const T1 = "#212121";
export const T2 = "#9E9E9E";
export const RED_BG = "#E7F3FF";
export const RED_FG = "#616161";
export const GRN_BG = "#E7F3FF";
export const GRN_FG = "#1877F2";
export const G200 = "#EEEEEE";
export const G300 = "#E0E0E0";
export const G500 = "#9E9E9E";
export const G700 = "#616161";
export const G900 = "#212121";
export const WHITE = "#FFFFFF";
export const CARD_SHADOW = "0 1px 4px rgba(0,0,0,0.08)";
export const CARD_HOVER = "0 2px 8px rgba(0,0,0,0.12)";

// ─── Report Type Options ──────────────────────────────────────────────────────
export const REPORT_TYPES = [
    { value: "general_ledger",    label: "General Ledger"    },
    { value: "bank_book",         label: "BankBook"          },
    { value: "cash_book",         label: "CashBook"          },
    { value: "day_book",          label: "DayBook"           },
    { value: "group_wise_summary", label: "Groupwise Summary" },
    { value: "sale_vs_purchase",  label: "Sale VS Purchase"  },
    { value: "inc_vs_exp",        label: "Inc. VS Exp."      },
];

// ─── Book Name Options ────────────────────────────────────────────────────────
export const BOOK_NAMES = ['BKR', 'BKP', 'CBR', 'CBP', 'SALE', 'PURC', 'CRNT', 'DBNT', 'CREXP', 'JV', 'OPBAL'];

// ─── MIS Report Type Options ──────────────────────────────────────────────────
export const MIS_SALE_REPORT_TYPES = [
    { value: "itemwise_sale",                label: "ItemWise Sale"                },
    { value: "partywise_itemwise_sale",      label: "Partywise/Itemwise Sale"      },
    { value: "itemwise_partywise_sale",      label: "Itemwise/Partywise Sale"      },
    { value: "itemwise_citywise_sale",       label: "Itemwise/Citywise Sale"       },
    { value: "citywise_itemwise_sale",       label: "Citywise/Itemwise Sale"       },
    { value: "partywise_citywise_sale",      label: "Partywise/Citywise Sale"      },
    { value: "citywise_partywise_sale",      label: "Citywise/Partywise Sale"      },
    { value: "itemwise_agentwise_sale",      label: "Itemwise/Agentwise Sale"      },
    { value: "agentwise_itemwise_sale",      label: "Agentwise/Itemwise Sale"      },
    { value: "monthly_sales_graph",          label: "Monthly Sales Graph"          },
];

export const MIS_PURCHASE_REPORT_TYPES = [
    { value: "itemwise_purchase",            label: "ItemWise Purchase"            },
    { value: "partywise_itemwise_purchase",  label: "Partywise/Itemwise Purchase"  },
    { value: "itemwise_partywise_purchase",  label: "Itemwise/Partywise Purchase"  },
    { value: "itemwise_citywise_purchase",   label: "Itemwise/Citywise Purchase"   },
    { value: "citywise_itemwise_purchase",   label: "Citywise/Itemwise Purchase"   },
    { value: "partywise_citywise_purchase",  label: "Partywise/Citywise Purchase"  },
    { value: "citywise_partywise_purchase",  label: "Citywise/Partywise Purchase"  },
    { value: "itemwise_agentwise_purchase",  label: "Itemwise/Agentwise Purchase"  },
    { value: "agentwise_itemwise_purchase",  label: "Agentwise/Itemwise Purchase"  },
    { value: "monthly_purchase_graph",       label: "Monthly Purchase Graph"       },
];

export const MIS_REPORT_TYPES = [...MIS_SALE_REPORT_TYPES, ...MIS_PURCHASE_REPORT_TYPES];

// ─── Shared SX Helpers ────────────────────────────────────────────────────────
export const cardSx = {
    background: WHITE,
    border: `1px solid ${G300}`,
    borderRadius: "12px",
    p: { xs: 1.5, sm: 2 },
};

export const btnOutlineSx = {
    background: "transparent",
    color: FB,
    border: `1.5px solid ${FB}`,
    borderRadius: "8px",
    fontSize: 13,
    fontWeight: 500,
    textTransform: "none",
    px: 2,
    height: 36,
    whiteSpace: "nowrap",
    "&:hover": { background: FB_LIGHT },
};

export const btnGhostSx = {
    background: "transparent",
    color: G700,
    border: `1px solid ${G300}`,
    borderRadius: "8px",
    fontSize: 13,
    fontWeight: 500,
    textTransform: "none",
    px: 2,
    height: 36,
    whiteSpace: "nowrap",
    "&:hover": { background: G200, color: G900 },
};

export const btnPrimarySx = {
    background: FB,
    color: WHITE,
    borderRadius: "8px",
    fontSize: 13,
    fontWeight: 500,
    textTransform: "none",
    px: 2,
    height: 36,
    whiteSpace: "nowrap",
    "&:hover": { background: FB_DARK },
    "&:disabled": { background: G300, color: G500 },
};

export const inputSx = {
    "& .MuiOutlinedInput-root": {
        borderRadius: "8px",
        background: G200,
        fontSize: 13,
        "& fieldset": { borderColor: G300 },
        "&:hover fieldset": { borderColor: FB },
        "&.Mui-focused fieldset": { borderColor: FB, borderWidth: 2 },
    },
};

export const selectSx = {
    borderRadius: "8px",
    background: G200,
    fontSize: 13,
    "& fieldset": { borderColor: G300 },
    "&:hover fieldset": { borderColor: FB },
    "&.Mui-focused fieldset": { borderColor: FB, borderWidth: 2 },
};

export const dgSx = {
    border: "none",
    "& .MuiDataGrid-columnHeaders": { background: FB_LIGHT, borderBottom: `2px solid ${G300}` },
    "& .MuiDataGrid-columnHeaderTitle": { fontSize: 11, fontWeight: 700, color: G700, letterSpacing: ".4px", textTransform: "uppercase" },
    "& .MuiDataGrid-cell": { borderBottom: `1px solid ${G200}`, outline: "none !important", display: "flex", alignItems: "center" },
    "& .MuiDataGrid-row:hover": { background: FB_LIGHT },
    "& .MuiDataGrid-row:nth-of-type(even)": { background: G200 },
    "& .MuiDataGrid-footerContainer": { borderTop: `1px solid ${G300}`, background: WHITE },
    "& .MuiTablePagination-root": { fontSize: 12, color: G700 },
};
